import React from 'react';
import "./Loader.css";
import loaderSvg from "../../assets/images/loader.svg"; 

function Loader({ text }) {
  return (
    <div className="loader-wrapper">
      <img src={loaderSvg} alt="Loading..." className="loader-svg" />
      {text && <p className="loader-text">{text}</p>}
    </div>
  );
}

export default Loader;